import {Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { ContentPosition } from 'src/app/model/ui-view.model';


@Directive({
  selector: '[appContentPosition]'
})
export class LogoPositionDirective implements OnInit, OnChanges {

  @Input('appContentPosition') contentPosition: ContentPosition | undefined;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    if (this.contentPosition) {
      this.updateContentPosition(this.contentPosition);
    }
  }


  ngOnChanges({ contentPosition }: SimpleChanges): void {
    if (contentPosition && contentPosition.currentValue !== contentPosition.previousValue) {
      this.updateContentPosition(contentPosition.currentValue);
    }
  }

  updateContentPosition = (position: ContentPosition) => {
    this.el.nativeElement.style.textAlign = position;
  }
}
